import {
  useNowPlayingCard,
  NowPlayingCardProvider,
} from './NowPlayingCardContext';

export default useNowPlayingCard;
export { NowPlayingCardProvider };
